var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 11.6663V4.99967C15.8334 4.08301 15.0834 3.33301 14.1667 3.33301H2.50004C1.58337 3.33301 0.833374 4.08301 0.833374 4.99967V11.6663C0.833374 12.583 1.58337 13.333 2.50004 13.333H14.1667C15.0834 13.333 15.8334 12.583 15.8334 11.6663ZM14.1667 11.6663H2.50004V4.99967H14.1667V11.6663ZM8.33337 5.83301C6.95004 5.83301 5.83337 6.94967 5.83337 8.33301C5.83337 9.71634 6.95004 10.833 8.33337 10.833C9.71671 10.833 10.8334 9.71634 10.8334 8.33301C10.8334 6.94967 9.71671 5.83301 8.33337 5.83301ZM19.1667 5.83301V14.9997C19.1667 15.9163 18.4167 16.6663 17.5 16.6663H3.33337V14.9997H17.5V5.83301H19.1667Z",
    fill: "#F7631B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentActive);
export default __webpack_public_path__ + "static/media/payment-active.c983794fc3a5fca4fc244a70feaad76d.svg";
export { ForwardRef as ReactComponent };